module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIUAAAAgCAYAAAA8C7thAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFxJREFUeNrs2cERABAMAMEw+m8ZBeCdjN0KEnN8RAAAAADk0LIONrfjwFvFg77tk3Gn7l4gCkSBKBAFokAUiAJRIApEQV2j2sCvPwS8FIgCUSAKRAEAAMD3lgADAFlTDCJoC6TBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/packages/components/lib/Keyboard/images/space.png
// module id = 1075
// module chunks = 0